import parseHTML from '../utils/_parseHtml';
import { addPageAttributeToTiles } from '../utils/_grid';
import wishlist from '../utils/_wishlist';
import dySendEngagement from '../utils/_dyHelpers';

class mSeeMore extends HTMLDivElement {
    constructor() {
        super();
        this.seeMoreBtn = this.querySelector('button');
        this.seenProductsParagraph = this.querySelector('p');
        this.plpGrid = this.parentElement.querySelector("[is='o-plp-grid']");
        this.personnalizedVariation = document.querySelector('.js-dyEngagement')?.dataset.personnalizedVariation;
        this.decisionId = document.querySelector('.js-dyEngagement')?.dataset.decisionId;
        this.slotId = document.querySelector('.js-dyEngagement')?.dataset.slotId;
        this.engagementUrl = document.querySelector('.js-dyEngagement')?.dataset.engagementUrl;
    }

    connectedCallback() {
        if (this.seeMoreBtn) { // no button if on the last page
            this.seeMoreBtn.addEventListener('click', () => {
                if (this.personnalizedVariation) {
                    dySendEngagement.sendEngagement({
                        engagementUrl: this.engagementUrl,
                        decisionId: this.decisionId,
                    });
                }

                this.loadNextProducts();
            });
        }
    }

    loadNextProducts() {
        if (this.seeMoreBtn.disabled) {
            return false;
        }
        this.seeMoreBtn.setAttribute('disabled', '');
        const { url } = this.seeMoreBtn.dataset;
        const tagNewHide = this.dataset.hideTagNew;
        const tagEventHide = this.dataset.hideTagEvent;
        const newPLP = this.seeMoreBtn.dataset.newPlp === 'true';
        const data = {
            selectedUrl: url, // not sure if this has any use case
            seenProducts: this.dataset.seenProducts,
            hideTagNew: tagNewHide,
            hideTagEvent: tagEventHide,
        };

        fetch(`${url}&newPLP=${newPLP}&${new URLSearchParams(data)}`, {
            Method: 'GET',
        }).then((response) => response.text(), // convert response to string
        ).then((responseString) => {
            const responseData = this.getResponseGridData(responseString);
            this.updateSeeMoreButtonData(responseData);
            this.seeMoreBtn.removeAttribute('disabled');
            this.plpGrid.append(responseData.html);

            wishlist.activateWishlistHeartButtons(); // Activate wishlist button for new loaded products

            if (responseData && responseData.pageNumber) {
                if (responseData.pageNumber === '2') {
                    document.dispatchEvent(new CustomEvent('oPlpGrid:addPageUrl', {
                        detail: {
                            pageNumber: 1,
                            pageUrl: window.location.href,
                        },
                    }));
                }

                document.dispatchEvent(new CustomEvent('oPlpGrid:addPageUrl', {
                    detail: {
                        pageNumber: responseData.pageNumber,
                        pageUrl: responseData.currentUrl,
                    },
                }));
            }
            document.dispatchEvent(new CustomEvent('oPlpGrid:initUrlUpdate'));
        });

        return true;
    }

    getResponseGridData(res) {
        let parsedHtml = parseHTML(res);
        // Store data in JS and delete element
        const productListLayout = parsedHtml.querySelector('.experience-dynamic-productList');
        const productListLayoutV2 = parsedHtml.querySelector('.experience-dynamic-productListV2');
        // if see more Page Designer
        if (productListLayout) {
            parsedHtml = parseHTML(productListLayout.innerHTML);
        }
        if (productListLayoutV2) {
            parsedHtml = parseHTML(productListLayoutV2.innerHTML);
        }
        const jsPagination = parsedHtml.querySelector('.js-pagination');
        // Remove pagination data from html before insertion in the DOM
        if (jsPagination) {
            parsedHtml.removeChild(jsPagination);
            // add currentPageNumber to new tiles
            parsedHtml = addPageAttributeToTiles(parsedHtml, jsPagination.dataset.pageNumber);
            // add currentPageNumber to already loaded tiles
            if (jsPagination.dataset.pageNumber === '2') {
                this.plpGrid.dataset.currentPage = '1';
                addPageAttributeToTiles(this.plpGrid, '1');
            } else {
                this.plpGrid.dataset.currentPage = (parseInt(jsPagination.dataset.pageNumber, 10) - 1).toString();
            }

            return {
                html: parsedHtml,
                pageNumber: jsPagination.dataset.pageNumber,
                currentUrl: jsPagination.dataset.currentUrl,
                pageSize: jsPagination.dataset.pageSize,
                sortOptionString: jsPagination.dataset.sortOptions,
                sortOption: JSON.parse(jsPagination.dataset.sortOptions),
                nextBtnUrl: jsPagination.dataset.nextBtnUrl,
                seenProducts: jsPagination.dataset.seenProducts,
                seenProductsWording: jsPagination.dataset.seenProductsWording,
            };
        }
        return false;
    }

    updateSeeMoreButtonData(object) {
        if (object.nextBtnUrl === '') {
            this.seeMoreBtn.remove();
            this.seeMoreBtn.dataset.url = object.nextBtnUrl;
        } else {
            this.seeMoreBtn.dataset.url = object.nextBtnUrl;
        }
        this.dataset.seenProducts = object.seenProducts;
        this.seenProductsParagraph.innerText = object.seenProductsWording;
    }
}

customElements.define('m-see-more', mSeeMore, {
    extends: 'div',
});
